import * as React from 'react';
import { SVGProps } from 'react';

export const DoubleBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.75 15.0625V12.25C4.75 11.7527 4.94754 11.2758 5.29917 10.9242C5.65081 10.5725 6.12772 10.375 6.625 10.375H14.125C14.6223 10.375 15.0992 10.5725 15.4508 10.9242C15.8025 11.2758 16 11.7527 16 12.25V15.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 15.0625V12.25C16 11.7527 16.1975 11.2758 16.5492 10.9242C16.9008 10.5725 17.3777 10.375 17.875 10.375H25.375C25.8723 10.375 26.3492 10.5725 26.7008 10.9242C27.0525 11.2758 27.25 11.7527 27.25 12.25V15.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.4375 15.0625H27.5625C28.2255 15.0625 28.8614 15.3259 29.3303 15.7947C29.7991 16.2636 30.0625 16.8995 30.0625 17.5625V23.5H1.9375V17.5625C1.9375 16.8995 2.20089 16.2636 2.66973 15.7947C3.13857 15.3259 3.77446 15.0625 4.4375 15.0625Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.9375 23.5V27.25"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.0625 23.5V27.25"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.25 15.0625V6.625C27.25 6.12772 27.0525 5.65081 26.7008 5.29917C26.3492 4.94754 25.8723 4.75 25.375 4.75H6.625C6.12772 4.75 5.65081 4.94754 5.29917 5.29917C4.94754 5.65081 4.75 6.12772 4.75 6.625V15.0625"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DoubleBed;
